<template>
  <div id="app">
    <AppHeader />
    <CookieConsent />
    <router-view />
    <AppFooter />
  </div>
</template>

<script>
import AppHeader from './components/AppHeader.vue';
import CookieConsent from './components/CookieConsent.vue';
import '@/assets/css/Globals.css';   
import '@/assets/css/Variables.css'; 

import AppFooter from './components/AppFooter.vue';
export default {
  name: 'App',
  components: {
    AppHeader,
    CookieConsent,
    AppFooter
  }
}
</script>

<style>
#app {
  /* font-family: Avenir, Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
